import { Statistic as AntStatistic, StatisticProps } from "antd";
import styled from "styled-components";

export const Statistic: typeof AntStatistic = styled(
  AntStatistic,
)<StatisticProps>``;
